<template>
    <div class="site">
        <topTitle class="top-title" :title="'移动能源运营监控调度大屏'">
            <template v-slot:topLeft>
                <div @click="stationListshow = true">
                    {{ stationObj.name }}
                </div>
            </template>
        </topTitle>
        <div class="content">
            <div class="site-left">
                <siteLeft></siteLeft>
            </div>
            <div class="site-center">
                <center></center>
            </div>
            <div class="site-right">
                <siteRight></siteRight>
            </div>
        </div>
        <!-- <div v-if="stationListshow" class="pop-box" @click="stationListshow = false">
            <div class="mpop-content">
                <span class="mpop-close">+</span>
                <div
                    class="pop-item"
                    v-for="(item, i) in stationList"
                    :key="'stationList' +i"
                    @click="change(i)">
                    {{ item.name }}
                </div>
            </div>
        </div> -->
        <city
            :show.sync="stationListshow"
            :hot="stationList"
            type="site"
            @upData="change" />
    </div>
</template>

<script>
import topTitle from '../components/topTitle.vue'
import center from './siteComponents/center.vue'

import siteLeft from './siteComponents/left.vue'
import siteRight from './siteComponents/right.vue'

import city from './../components/city.vue'
export default {
    components: {
        topTitle,
        siteLeft,
        center,
        siteRight,
        city
    },
    data() {
        return {
            stationListshow: false,
            stationList: [
                {
                    name: "衡阳蒸湘南路站",
                    value: '5104e41fea524665bcf552f2fdd5658a'
                },
                {
                    name: "衡阳新园路站",
                    value: '615f3932-0531-4d86-9105-729cc289c2f5'
                },
                {
                    name: "荆州北京东路站",
                    value: 'd778c320-fb0c-4ce0-8cdb-17d4c17841de'
                },
                {
                    name: "无锡锡沪路站",
                    value: 'ba7852ec-afe7-4ab3-9535-6addad0e53ec'
                }
            ],
            stationAt: 0,
            stationId: '',
            stationName: '',
            stationObj: {
                stationId: '',
                stationName: '',
            }
        }
    },
    provide() {
        return {
            stationObj: () => this.stationObj
            // stationId: () => this.stationId,
            // stationName: () => this.stationName
        }
    },
    mounted() {
        // setTimeout(() => {
        // this.change()
        // }, 4000)
        // this.stationId = this.stationList[this.stationAt].value
        // this.stationName = this.stationList[this.stationAt].name

        this.stationObj = {
            ...this.stationList[0]
        }
    },
    methods: {
        change(i) {
            this.stationObj = {
                value: i.id || i.value,
                name: i.stationName || i.name,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.site {
    height: 100%;
    position: relative;
    &::before {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        content: '';
        background: url(~@/assets/images/energyMuseum/sitebg.png);
        background-size: 100% 100%;
        opacity: 0.3;
        z-index: 0;
    }
    .content {
        height: 100%;
        position: relative;
        display: flex;
        z-index: 1;
        .site-left, .site-right {
            width: 560px;
            flex-shrink: 0;
        }
        .site-center {
            height: 100%;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
        }
    }
    .pop-box {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        background: rgba(#fff, .3);
        .mpop-content {
            background: linear-gradient(180deg,rgba(35,94,92,.8),rgba(36,98,96,.8));
            width: 700px;
            position: absolute;
            padding: 50px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            > div {
                margin-top: 20px;
            }
        }
        .mpop-close {
            position: absolute;
            background: linear-gradient(180deg,rgba(35,94,92,.8),rgba(36,98,96,.8));
            top: -25px;
            right: -25px;
            width: 50px;
            height: 50px;
            color: #fff;
            border: 1px solid #fff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: rotate(-45deg);
        }
    }
}
</style>